import React from 'react';
import { VerticalNavigationProps } from './types';

const VerticalNavigation = (_: VerticalNavigationProps) => <></>;

export default VerticalNavigation;
